export const SECTOR_METRIC_LABELS = {
    of_total: '% of TOTAL',
    // active_alarms: hide while NULL (wired in SectorList via empty/null filter).
    active_alarms: 'ACTIVE ALARMS',
    offline_inverters: 'OFFLINE INVERTERS',
    offline_dcdc_conv: 'OFFLINE DCDC CONV',
    high_voltage: 'HIGH VOLTAGE',
    low_voltage: 'LOW VOLTAGE',
    ac_power: 'AC POWER',
    pv_dc_power: 'PV DC POWER',
};

export const SECTOR_TABLE_HEADERS = {
  device: 'Device',
  production: 'Production',
  storage: 'Storage',
  ac_power: 'AC Power',
  pv_dc_power: 'PV DC Power',
  of_total: 'of Total',
  offline_inverters: 'Offline Inverters',
  offline_dcdc_conv: 'Offline DCDC Conv.',
  temperature: 'Current Temp',
  max_temp: 'Max Temp',
  min_temp: 'Min Temp',
  high_voltage: 'High Side Voltage',
  low_voltage: 'Low Side Voltage',
  vars: 'VARs',
};
